import type { Customer } from 'src/app/customer/CustomerComboboxField';
import type { IQuotationLineValues } from '../types';

export type ActiveWindow = 'NAME_DRAFT' | 'UPLOAD' | 'PROCESSING' | 'REVIEW_LANES' | 'DRAFT_OFFERTE';

export type IAIDraftState = {
  activeWindow: ActiveWindow;
  draftName: string;
  draftId: string | null;
  files: globalThis.File[];
  extraContext: string;
  isExtracting: boolean;
  extractionError: string | null;
  lanes: IQuotationLineValues[];
  customer: Customer | null;
};

export type AIDraftAction =
  | { type: 'SET_DRAFT_NAME'; draftName: string }
  | { type: 'SET_FILES'; files: File[] }
  | { type: 'SET_EXTRA_CONTEXT'; extraContext: string }
  | { type: 'START_EXTRACTION'; draftId: string }
  | { type: 'EXTRACTION_SUCCESS'; lanes: IQuotationLineValues[] }
  | { type: 'EXTRACTION_ERROR'; error: string }
  | {
      type: 'RESTORE_DRAFT';
      draftId: string;
      draftName: string;
      lanes?: IQuotationLineValues[];
      activeWindow: ActiveWindow;
    }
  | { type: 'SET_LANES'; lanes: IQuotationLineValues[] }
  | { type: 'SET_CUSTOMER'; customer: Customer | null }
  | { type: 'GO_BACK' }
  | { type: 'GO_FORWARD' };

export const initialAIDraftState: IAIDraftState = {
  activeWindow: 'NAME_DRAFT',
  draftName: '',
  draftId: null,
  files: [],
  extraContext: '',
  isExtracting: false,
  extractionError: null,
  lanes: [],
  customer: null,
};

export function aiDraftReducer(state: IAIDraftState, action: AIDraftAction): IAIDraftState {
  switch (action.type) {
    case 'SET_DRAFT_NAME': {
      return { ...state, draftName: action.draftName };
    }
    case 'SET_FILES': {
      return { ...state, files: action.files };
    }
    case 'SET_EXTRA_CONTEXT': {
      return { ...state, extraContext: action.extraContext };
    }
    case 'START_EXTRACTION': {
      return {
        ...state,
        isExtracting: true,
        extractionError: null,
        draftId: action.draftId,
        activeWindow: 'PROCESSING',
      };
    }
    case 'EXTRACTION_SUCCESS': {
      return {
        ...state,
        isExtracting: false,
        extractionError: null,
        lanes: action.lanes,
        activeWindow: 'REVIEW_LANES',
      };
    }
    case 'EXTRACTION_ERROR': {
      return { ...state, isExtracting: false, extractionError: action.error };
    }
    case 'RESTORE_DRAFT': {
      return {
        ...state,
        draftId: action.draftId,
        draftName: action.draftName,
        lanes: action.lanes ?? [],
        activeWindow: action.activeWindow,
        isExtracting: action.activeWindow === 'PROCESSING',
      };
    }
    case 'SET_LANES': {
      return { ...state, lanes: action.lanes };
    }
    case 'SET_CUSTOMER': {
      return { ...state, customer: action.customer };
    }
    case 'GO_BACK': {
      let newWindow = state.activeWindow;
      if (state.activeWindow === 'UPLOAD') {
        newWindow = 'NAME_DRAFT';
      } else if (state.activeWindow === 'REVIEW_LANES') {
        newWindow = 'UPLOAD';
      } else if (state.activeWindow === 'DRAFT_OFFERTE') {
        newWindow = 'REVIEW_LANES';
      }
      return { ...state, activeWindow: newWindow };
    }
    case 'GO_FORWARD': {
      let newWindow = state.activeWindow;
      if (state.activeWindow === 'NAME_DRAFT') {
        newWindow = 'UPLOAD';
      } else if (state.activeWindow === 'REVIEW_LANES') {
        newWindow = 'DRAFT_OFFERTE';
      }
      return { ...state, activeWindow: newWindow };
    }
  }

  return state;
}
